import api from '@/api'

export default {
  all: (filter) => api('get', '/contact', filter),
  create: (data) => api('post', '/contact', data),
  show: (id) => api('get', `/contact/${id}`),
  delete: (id) => api('delete', `/contact/${id}`),
  update: (data) => api('put', `/contact/${data.id}`, data)
}